import { EonUiLink } from "@eon-ui/eon-ui-components-react";
import "./QuickActionLinks.scss";
import { useTranslation } from "@me8eon/translation";
import React, { useContext, useEffect, useState } from "react";
import { useWindowProperties } from "../../context/WindowContext";
import { AiAssistContext } from "./AiAssist.context";
import { Icon } from "@me8eon/icons";
import { useFeatureFlag } from "@me8eon/featureflags";
import { useDoAi } from "@me8eon/react_intent";
import { useLoadingFlag } from "@me8eon/async";
import { useUserData } from "@me8eon/react_authentication";
import { QuickActionType } from "../../modules/AiWidgets/widget.types";

interface QuickActionLinksProps {
    onItemClick?: (item: string) => void;
    isInHeader?: boolean
}

interface ActionItemList {
    type: QuickActionType;
    icon: string;
    disabled?: boolean;
}

const QuickActionLinks = ({
    onItemClick,
    isInHeader
}: QuickActionLinksProps) => {
    const [loading] = useLoadingFlag()
    const handleAiQueryIntent = useDoAi()

    const t = useTranslation();

    const [showQuickLinks, setShowQuickLinks] = useState<boolean>(true);
    const { isMobile } = useWindowProperties();
    const actionItemsList: ActionItemList[] = [
        { type: "createIncident", icon: "alert" },
        { type: "chatWithServiceDesk", icon: "messenger_01" },
        { type: "requestCallback", icon: "talk_to_us" }
    ];

    const { setQuickActionType, currentAgent } = useContext(AiAssistContext);

    const toggleQuickActions = () => {
        setShowQuickLinks(!showQuickLinks);
    };

    useEffect(() => {
        setShowQuickLinks(!isMobile);
    }, [isMobile]);

    const handleClick = (item: QuickActionType) => {
        console.log("Clicked item:", item);
        const query = t(`chatBot.quickActions.actions.${item}`);
        setQuickActionType(item);
        if (loading || !query) return;
        handleAiQueryIntent(query);
        isMobile && toggleQuickActions();
        if (onItemClick) {
            onItemClick(query);
        }
    };

    const callIcon = <span className="support-icon"><Icon size="normal" name="support" /></span>;

    return (
        (currentAgent === "itsupport") ? <div className="ai-assist-quick-action">
            <div className="heading" onClick={isMobile ? toggleQuickActions : undefined}>
                <span className="icon"><Icon size="normal" name="support" /></span>
                {!isInHeader && (<span className="text">{t("chatBot.quickActions.heading")}</span>)}
                {callIcon}
            </div>
            <div className="quick-links-wrapper" style={{ display: showQuickLinks ? 'flex' : 'none' }}>
                {isInHeader && (
                    <div>
                        <div className="quick-item-row quick-item-row--heading">
                            {callIcon}
                            <span className="text">{t("chatBot.quickActions.heading")}</span>
                        </div>
                        <div onClick={toggleQuickActions} className="close-icon">
                            <Icon name="close" />
                        </div>
                    </div>
                )}
                {actionItemsList.map((item, index) => (
                    <EonUiLink
                        key={index}
                        className="quick-item-row"
                        onClick={() => !item.disabled && handleClick(item.type)}
                        icon={item.icon}
                        iconPosition="left"
                        text={t(`chatBot.quickActions.actions.${item.type}`)}
                        title={t(`chatBot.quickActions.tooltips.${item.type}`)}
                        size="small"
                    ></EonUiLink>
                ))}
            </div>
        </div> : <></>
    );
};

export default QuickActionLinks;
